import Icon from '../../../components/AppIcon';
import { ProcessStep } from '../types';

interface ConsultationProcessProps {
  steps: ProcessStep[];
}

const ConsultationProcess = ({ steps }: ConsultationProcessProps) => {
  return (
    <section className="py-16 bg-surface">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-brand-primary mb-4">
            How The Consultation Works
          </h2>
          <p className="text-lg text-text-secondary max-w-2xl mx-auto">
            A simple, structured process designed to maximize value in minimal time
          </p>
        </div>
        
        <div className="relative">
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-0.5 bg-gradient-to-r from-primary via-accent to-primary transform -translate-y-1/2"></div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative">
            {steps.map((step, index) => (
              <div key={step.id} className="relative">
                <div className="bg-card border-2 border-border rounded-xl p-6 hover:border-primary transition-colors duration-fast">
                  <div className="flex items-center justify-between mb-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-primary to-accent rounded-full flex items-center justify-center text-white font-bold text-lg">
                      {step.number}
                    </div>
                    <div className="text-xs text-text-secondary bg-muted px-3 py-1 rounded-full">
                      {step.duration}
                    </div>
                  </div>
                  
                  <h3 className="text-lg font-semibold text-brand-primary mb-2">
                    {step.title}
                  </h3>
                  
                  <p className="text-sm text-text-secondary leading-relaxed">
                    {step.description}
                  </p>
                </div>
                
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                    <Icon name="ArrowRight" size={24} className="text-primary" />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
        
        <div className="mt-12 text-center">
          <div className="inline-flex items-center space-x-2 bg-success/10 text-success px-6 py-3 rounded-full">
            <Icon name="Clock" size={20} />
            <span className="font-medium">Total Time: 30 Minutes | Value: Priceless</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConsultationProcess;